// eslint-disable-next-line no-restricted-imports -- This file is the Kobo wrapper for the component
import { Modal as ModalMantine } from '@mantine/core'
import type { ModalProps as ModalPropsMantine } from '@mantine/core'

export type ModalNewProps = ModalPropsMantine

export default ModalMantine
